"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLiveChatResponse = void 0;
/**
 * Returns true if the response is a liveChat response.
 * @param response
 */
function isLiveChatResponse(response) {
    var _a;
    return ((_a = response === null || response === void 0 ? void 0 : response.extensionData) === null || _a === void 0 ? void 0 : _a.MessageSource) === 'LiveChat';
}
exports.isLiveChatResponse = isLiveChatResponse;
//# sourceMappingURL=Utils.js.map